import styled from 'styled-components';
import { color, global, typography } from 'styles/settings';
import { withModifiers } from 'utils';

export const ConfirmationContainer = styled.div``;

export const ConfirmationTitle = styled.div`
  ${typography.font.title.bold}
  color: ${color.neutral.plainBlack};
  font-size: ${typography.size.xxxl};
`;

export const ConfirmationMessage = styled.div`
  color: ${color.neutral.plainBlack};
  ${typography.font.regular}
  font-size: ${typography.size.md};

  ${withModifiers('bold')`
    font-weight: bold;
  `}
`;

export const ConfirmationFooter = styled.div`
  margin-top: ${global.space.md};
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
`;
